import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const AddonSlider = ({ className = "", ...props }) => (
  <ul
    className={cn(
      "overscroll-touch relative flex list-none gap-8 overflow-y-hidden overflow-x-scroll",
      className
    )}
    {...props}
  />
)

AddonSlider.propTypes = {
  className: PropTypes.string,
}

export const AddonItem = ({ className = "", disabled, ...props }) => (
  <li
    className={cn(
      "relative",
      disabled ? "opacity-50" : "opacity-100",
      className
    )}
    {...props}
  />
)

AddonItem.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export const DetailText = ({ className = "", ...props }) => (
  <p className={cn("text-12 leading-14 font-medium", className)} {...props} />
)

DetailText.propTypes = {
  className: PropTypes.string,
}

export const RetailPrice = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-grey-65 text-12 tablet:font-medium font-light leading-none tracking-wide",
      className
    )}
    {...props}
  />
)

RetailPrice.propTypes = {
  className: PropTypes.string,
}
